import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { BankAccountComponent } from '../bank-account/bank-account.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bank-account-list',
  templateUrl: './bank-account-list.component.html',
  styleUrls: ['./bank-account-list.component.css']
})
export class BankAccountListComponent implements OnInit {

  public menu_item_id = '20';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];

  displayedColumns = ['acct_number', 'acct_name', 'bank_name', 'baseline_amount', 'balance', 'edit', 'del'];
  displayedColumns2 = ['acct_number', 'acct_name', 'bank_name', 'baseline_amount', 'balance'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<BankAccountComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'table_name': 'bank_account', 'bank_acct_number': '', 'account_name': '', 'title': 'الحسابات البنكية' };

  Success_Msg; Error_Msg; Bank_Account_List; Acct_Name; Acct_No; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Bank_Account_List').subscribe((res: string) => {
      this.Bank_Account_List = res;
    });
    this.model['title'] = this.Bank_Account_List;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Acct_Name').subscribe((res: string) => {
      this.Acct_Name = res;
    });

    translate.get('Acct_No').subscribe((res: string) => {
      this.Acct_No = res;
    });

  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }


  search() {
    let obj = {
      cmd: 'getBankAcctList', account_name: this.model['account_name'],
      bank_acct_number: this.model['bank_acct_number']
    };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.status['msg'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // let condition = "";
    // if(this.model['account_name'] != '') 
    //      condition = "(`bank_account`.`account_name` LIKE '%" + this.model['account_name'] + 
    //     "%' OR `bank_account`.`account_name_en` LIKE '%" + this.model['account_name'] + "%') AND ";

    // if( this.model['bank_acct_number'] != '')
    //       condition += "`bank_account`.`bank_acct_number` LIKE '%" + this.model['bank_acct_number'] +"' AND ";

    // let query = "SELECT `bank_account`.*,`bank_base`.`baseline_amount`,`bank_base`.`account_id` FROM  `bank_account`,`bank_base` WHERE"+
    // " `bank_account`.`acct_number` = `bank_base`.`acct_number` AND "+
    // condition + "`bank_account`.`status` =  '1'";

    // let obj = {cmd: 'getList', query:query};

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.dp = data.data['list'];
    //     this.dp.forEach(element => {
    //       element.acct_name = element.account_name + ' (' + element.bank_acct_number + ')';
    //     });
    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;
    //   });

  }

  newBankAcctEntry() {
    this.addDialogRef = this.dialog.open(BankAccountComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="50%"> ' + this.Acct_Name + ': ' + this.model['account_name'] + '</td>';
    html_data += '<td width="50%"> ' + this.Acct_No + ': ' + this.model['bank_acct_number'] + ' </td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('bank_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  editBankAcct(row) {

    let dialog_data = [{
      'table_name': 'bank_account', 'account_id': row.account_id, 'bank_acct_number': row.bank_acct_number,
      'account_name': row.account_name, 'bank_name': row.bank_name, 'account_name_en': row.account_name_en,
      'bank_name_en': row.bank_name_en, 'iban': row.iban, 'start_date': row.start_date, 'currency': row.currency,
      'key': 'account_id', 'flag': 'update', 'country_id': row.country_id,
      'comment': row.comment, 'acct_number': row.acct_number
    }, {
      'table_name': 'acct_base', 'acct_number': row.acct_number,
      'baseline_amount': row.baseline_amount
    }];

    this.addDialogRef = this.dialog.open(BankAccountComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delBankAcct(row) {
    if (confirm(this.Del_Msg)) {

      let values = [{ 'table_name': this.model['table_name'], 'account_id': row.account_id },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          //console.log(data);
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else
            alert(this.Error_Msg);

        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}




